import { Link } from 'react-router-dom';

import { EmptyState } from './ui/EmptyState';
import { PageHeader } from './ui/PageHeader';

export function NotFoundPage() {
  return (
    <div className="flex flex-col gap-4">
      <PageHeader title="Страница не найдена" />
      <EmptyState
        icon="🧭"
        title="404 — такой страницы нет"
        description="Возможно, ссылка устарела или матч ещё не опубликован."
        action={
          <Link
            to="/"
            className="inline-flex min-h-11 items-center rounded-control border border-line-strong px-4 text-sm font-semibold text-ink hover:bg-surface-raised"
          >
            На главную
          </Link>
        }
      />
    </div>
  );
}

export default NotFoundPage;
